import { render, staticRenderFns } from "./editgroup.vue?vue&type=template&id=5ec8b0b4&scoped=true&"
import script from "./editgroup.vue?vue&type=script&lang=js&"
export * from "./editgroup.vue?vue&type=script&lang=js&"
import style0 from "./editgroup.vue?vue&type=style&index=0&id=5ec8b0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8b0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec8b0b4')) {
      api.createRecord('5ec8b0b4', component.options)
    } else {
      api.reload('5ec8b0b4', component.options)
    }
    module.hot.accept("./editgroup.vue?vue&type=template&id=5ec8b0b4&scoped=true&", function () {
      api.rerender('5ec8b0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/usergroup/editgroup.vue"
export default component.exports